module.exports = __webpack_public_path__ + "static/media/sport-back.5f79b82e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sport-back.svg
// module id = 481
// module chunks = 7